import CaregiverChrcStateCompliancePage from "./CaregiverChrcStateCompliancePage";

export default function CaregiverChrcStateComplianceRoute() {
  return (
    <>
      <CaregiverChrcStateCompliancePage />
    </>
  );
}
